const CONTENT = {
  pageDataAid: "changeRiskProfile",
  navigationHeader: {
    dataAid: "changeRiskProfile",
    title: "Change risk profile",
    defaultTitle: "Select risk profile",
  },
  riskOptionDataAid: "option",
  riskData: {
    titleSubtext: 'risk profile',
    defaultSubtitle: 'Below recommended funds are as per your risk profile',
    customSubtitle: 'Below recommended funds are as per your equity-debt distribution',
  },
  customiseEquityDebt: {
    dataAid: "linkSmallIcon",
    title: {
      text: "Customise equity-debt distribution",
    },
    rightIconDataAid: "right",
  },
  note: {
    title: {
      text: "Note:",
      dataAid: "note",
    },
    subTitle: {
      text: "If you change your risk profile, fund recommendations will change accordingly",
      dataAid: "subtitle",
    },
  },
  cta: {
    text: "CONFIRM",
    dataAid: "primary",
  },
};

const RISK_OPTIONS = [
  {
    dataAid: "aggressive",
    title: "Aggressive",
    subtitle: "Distribution: 90% Equity | 10% Debt",
    value: "Aggressive",
    iconName: 'risk_icon_aggressive.svg',
  },
  {
    dataAid: "moderatelyAggressive",
    title: "Moderately aggressive",
    subtitle: "Distribution: 80% Equity | 20% Debt",
    value: "Moderately Aggressive",
    iconName: 'risk_icon_aggressive.svg',
  },
  {
    dataAid: "moderate",
    title: "Moderate",
    subtitle: "Distribution: 70% Equity | 30% Debt",
    value: "Moderate",
    iconName: 'risk_icon_moderate.svg',
  },
  {
    dataAid: "moderatelyConservative",
    title: "Moderately conservative",
    subtitle: "Distribution: 60% Equity | 40% Debt",
    value: "Moderately Conservative",
    iconName: 'risk_icon_moderate.svg',
  },
  {
    dataAid: "conservative",
    title: "Conservative",
    subtitle: "Distribution: 50% Equity | 50% Debt",
    value: "Conservative",
    iconName: 'risk_icon_conservative.svg',
  },
];

const CUSTOM_EQUITY_DEBT_RATIO_BOTTOMSHEET = {
  dataAid: "customiseRiskChange",
  title: {
    text: " Customise equity-debt distribution",
    dataAid: "header",
  },
  slider: {
    dataAid: "customise",
    risk: {
      text: "Low risk",
      dataAid: "risk",
      minValue: 0,
      maxValue: 100,
    },
    returns: {
      text: "Moderate returns",
      dataAid: "returns",
    },
    value1: {
      text: "% Stocks",
      dataAid: "value1",
    },
    value2: {
      text: "% Bonds",
      dataAid: "value2",
    },
  },
  note: {
    text: "Note:",
    dataAid: "note",
  },
  subtitle: {
    text: "We do not recommend changing the custom equity-debt distribution if you are new to investing",
    dataAid: "subtitle",
  },
  buttonTitle: {
    text: "SAVE CHANGES",
    dataAid: "primary",
  },
};

const CUSTOM_OPTION_DATA = {
  dataAid: "custom",
  title: "Custom",
  subtitle: (equity, debt) => `Distribution: ${equity}% Equity | ${debt}% Debt`,
  value: "Custom",
  iconName: 'risk_icon_custom.svg',
};

const CHANGE_RISK_PROFILE = {
  ...CONTENT,
  RISK_OPTIONS,
  CUSTOM_OPTION_DATA,
  CUSTOM_EQUITY_DEBT_RATIO_BOTTOMSHEET,
};

export default CHANGE_RISK_PROFILE;
